import React, { useState, useEffect } from 'react'
import {
    useNavigate,
    useParams
} from "react-router-dom";

import { Card } from '../../common/Card'
import { CDN_URL } from "../../Utils/bootstrap";
import $ from 'jquery'
import SharePopup from '../../common/SharePopup';
export default function ListDetail(props) {
    const [items, setItems] = useState([]);
    const [details, setDetails] = useState([]);
    const [imagesrc, setImagesrc] = useState("")

    const [link, setLink] = useState("")
    const [quote, setQuote] = useState("")
    const [twittermessage, setTwittermessage] = useState("")
    const [shareType, setShareType] = useState("")

    const { id } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        let data = JSON.parse(localStorage.getItem("listResult"));
        setItems(data)
    }, []);

    useEffect(() => {
        updateDetailsObject();
    }, [items, id])

    const updateDetailsObject = () => {
        for (let index = 0; index < items.length; index++) {
            let ImageId = items[index].Face.ImageId;
            if (id == ImageId) {
                setImagesrc(items[index].Face.ExternalImageId)
                setDetails(items[index])
                break;
            }
        }
    }

    const handleBack = () => {
        navigate("/list" + window.location.search)
    }

    const share = (img) => {
        console.log("image", img);
        $(".popup_fixed_bg").show();
        let link = `${CDN_URL}${img}`;
        setLink(link);
    }

    let imgarr = imagesrc.split('.');
    let imgext = "jpg"
    imgext = imgarr && imgarr[1] && imgarr[1];
    return (
        <>
            <div className="container-fluid">
                <div className="cardarrow_flex">
                    <img src="/assets/images/arrowback.svg" className="arrow_back" alt="" onClick={() => handleBack()} />
                    <div className="card_box_bg">
                        <div className="row">
                            <div className="col-sm-8 card_list_col">
                                <h4>Your Photo(s)</h4>
                                {/* <span className="border_head">|</span> <span className="heading_date">{getDateTime()} New Delhi</span> */}
                                {/* <h4>During the meeting with Prime Minister of India Narendra Modi. <span className="border_head">|</span> <span className="heading_date">October 4, 2021 New Delhi</span></h4> */}
                                <Card items={items} />
                            </div>
                            <div className="col-sm-4 card_left_border">
                                <div className="card_expand_img">
                                    <img src={imagesrc ? CDN_URL + imagesrc : ""} className="img-fluid rounded" alt="" />
                                    <img src="/assets/images/expand.svg" className="expand_icon2" alt="" />
                                </div>
                                <div className="card_img_btns">
                                    <ul>
                                        <li className="img_name">
                                            <h5>{imagesrc ? imagesrc : ""}</h5>
                                        </li>
                                        <li>
                                            <button type="button" className="download_btn">
                                                <a href={CDN_URL + imagesrc + "?ignore.zip"}>
                                                    <img src="/assets/images/downloadwhite.svg" alt="" /> download
                                                </a>
                                            </button>
                                        </li>
                                        {/* onClick={() => share(imagesrc)} */}
                                        {/* <li>
                                            <button type="button" >
                                                <img src="/assets/images/sharewhite.svg" alt="" /> share
                                            </button>
                                        </li> */}
                                    </ul>
                                </div>
                                <div className="card_info">
                                    <h6>information</h6>
                                    <ul>
                                        <li>
                                            <h5>Title</h5>
                                        </li>
                                        <li>
                                            <h6>{imagesrc}</h6>
                                        </li>
                                    </ul>

                                    {/* <ul>
                                        <li>
                                            <h5>Size</h5>
                                        </li>
                                        <li>
                                            <h6>3.8 mb</h6>
                                        </li>
                                    </ul> */}

                                    <ul>
                                        <li>
                                            <h5>Format</h5>
                                        </li>
                                        <li>
                                            <h6>{imgext}</h6>
                                        </li>
                                    </ul>

                                    {/* <ul>
                                        <li>
                                            <h5>Uploaded</h5>
                                        </li>
                                        <li>
                                            <h6>October 4, 2021</h6>
                                        </li>
                                    </ul>

                                    <ul>
                                        <li>
                                            <h5>Dimmensions</h5>
                                        </li>
                                        <li>
                                            <h6>1600 X 1200</h6>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                        <SharePopup link={link} quote={quote} twittermessage={twittermessage} shareType={shareType} />
                    </div>

                </div>
            </div>
        </>

    )
}
